module.exports = __webpack_public_path__ + "static/media/moreto-love-all-prod-icon.d2daae5a.svg";